import React from 'react';

const SvgComponent = props => (
  <svg
    width={167}
    height={104}
    viewBox="0 0 167 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      stroke="#2F6ECD"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M52.8005 53.9043H31.7588V66.9264H52.8005V53.9043Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M74.478 70.1033L61.059 65.0215H23.5014L10.0823 70.1033C4.92116 72.0089 1.50684 77.0113 1.50684 82.4901V102.351H83.0535V82.4901C83.0535 77.0113 79.6392 72.0089 74.478 70.1033Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M65.7452 38.5813H61.9338V27.7031H65.904C68.1273 27.7031 69.9535 29.5294 69.9535 31.7527V34.2936C70.0329 36.755 68.1273 38.5813 65.7452 38.5813Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M18.8184 38.5813H22.6297V27.7031H18.6596C16.4363 27.7031 14.6101 29.5294 14.6101 31.7527V34.2936C14.5307 36.755 16.4363 38.5813 18.8184 38.5813Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M42.3204 59.9398C31.4422 59.9398 22.5491 51.0467 22.5491 40.1685V23.7321C22.5491 19.6826 25.884 16.3477 29.9335 16.3477H54.5484C58.598 16.3477 61.9329 19.6826 61.9329 23.7321V40.4067C61.9329 51.1261 53.1192 59.9398 42.3204 59.9398Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M20.4834 9.99488C17.5455 16.9823 19.4511 23.1757 22.389 23.1757H59.629C62.5669 23.1757 64.3137 20.7143 65.0284 17.7764C65.743 14.8385 67.8075 4.35728 67.8075 4.35728C67.8869 4.43668 27.312 -6.2033 20.4834 9.99488Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path d="M38.802 35.2949L45.6608 35.2949" strokeWidth="2" />
      <path
        d="M19.0538 86.4591C21.9042 86.4591 24.2149 84.1483 24.2149 81.2979C24.2149 78.4475 21.9042 76.1367 19.0538 76.1367C16.2033 76.1367 13.8926 78.4475 13.8926 81.2979C13.8926 84.1483 16.2033 86.4591 19.0538 86.4591Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M19.0548 81.7751C19.3179 81.7751 19.5312 81.5618 19.5312 81.2987C19.5312 81.0356 19.3179 80.8223 19.0548 80.8223C18.7917 80.8223 18.5784 81.0356 18.5784 81.2987C18.5784 81.5618 18.7917 81.7751 19.0548 81.7751Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M54.5485 64.1465V70.4987C54.5485 76.9303 49.0697 82.0915 42.241 82.0915C35.4918 82.0915 29.9336 76.9303 29.9336 70.4987V64.1465"
        strokeWidth="2"
      />
      <path
        d="M42.2393 82.0918V88.2852C42.2393 94.7168 37.0782 99.878 30.6465 99.878C24.2149 99.878 19.0537 94.7168 19.0537 88.2852V86.5384"
        strokeWidth="2"
      />
      <path d="M62.8057 83.998V91.5413" strokeWidth="3" />
      <path d="M66.6182 87.8105H59.075" strokeWidth="3" />
      <path
        d="M34.6981 41.041H32.316C30.0133 41.041 28.1077 39.1353 28.1077 36.8326V34.4505C28.1077 32.1479 30.0133 30.2422 32.316 30.2422H34.6981C37.0008 30.2422 38.9064 32.1479 38.9064 34.4505V36.8326C38.9064 39.1353 37.0802 41.041 34.6981 41.041Z"
        fill="#fff"
        strokeWidth="2"
      />
      <path
        d="M52.0865 41.121H49.7044C47.4018 41.121 45.4961 39.2154 45.4961 36.9127V34.5306C45.4961 32.2279 47.4018 30.3223 49.7044 30.3223H52.0865C54.3892 30.3223 56.2949 32.2279 56.2949 34.5306V36.9127C56.2949 39.2154 54.3892 41.121 52.0865 41.121Z"
        fill="#fff"
        strokeWidth="2"
      />
    </g>
    <g>
      <path
        d="M148.224 19.4511C147.611 21.06 146.615 22.3624 145.236 22.8987C145.465 23.6648 145.619 24.431 145.619 25.2737V29.1044H149.449C149.986 29.1044 150.522 29.2577 150.982 29.4109C150.599 14.8542 147.457 12.0195 147.457 12.0195C148.453 14.8542 148.607 17.4591 148.224 19.4511Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M151.059 39.2172C150.522 39.4471 149.909 39.6003 149.297 39.6003H145.619V41.3624C145.619 51.7819 137.115 60.2094 126.772 60.2094C116.276 60.2094 107.695 51.6287 107.695 41.1326V39.6003H104.018C103.328 39.6003 102.715 39.4471 102.179 39.1406C101.566 55.0763 95.3604 57.1449 95.3604 57.1449C95.3604 57.1449 102.639 61.6651 126.619 60.2094C150.676 61.6651 157.877 57.1449 157.877 57.1449C157.877 57.1449 151.672 55.1529 151.059 39.2172Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.694 29.1806V25.3499C107.694 24.5838 107.847 23.8943 108 23.2048C106.315 22.7451 105.166 21.366 104.476 19.6039C104.17 17.995 104.17 16.0031 104.629 13.7812C103.71 15.9264 102.408 20.4467 102.178 29.5637C102.714 29.3339 103.25 29.1806 103.863 29.1806H107.694Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M151.059 29.4861C150.599 29.2563 150.063 29.1797 149.527 29.1797H145.696V39.6758H149.374C149.986 39.6758 150.599 39.5226 151.136 39.2927C152.515 38.6032 153.434 37.2241 153.434 35.6153V33.1636C153.434 31.4781 152.438 30.0991 151.059 29.4861Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.865 29.1797C103.252 29.1797 102.716 29.3329 102.179 29.5628C100.877 30.1757 99.8809 31.5547 99.8809 33.087V35.5386C99.8809 37.1475 100.8 38.45 102.103 39.1395C102.639 39.4459 103.328 39.5992 103.941 39.5992H107.619V29.1797H103.865Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.696 60.2848C122.942 60.2848 119.418 59.2122 116.43 57.2969V73.0793H136.733V57.3735C133.898 59.2122 130.45 60.2848 126.696 60.2848Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M145.16 22.9746C144.623 23.2045 144.01 23.3577 143.397 23.3577H108.768C108.461 23.3577 108.232 23.2811 108.002 23.2045C107.772 23.894 107.695 24.5835 107.695 25.3496V29.1803V39.6764V41.2087C107.695 47.9507 111.22 53.85 116.506 57.221C119.494 59.1364 123.018 60.209 126.772 60.209C130.45 60.209 133.897 59.1364 136.809 57.2976C142.095 54.0032 145.619 48.104 145.619 41.3619V39.5998V29.1803V25.3496C145.619 24.5069 145.466 23.6641 145.16 22.9746Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.695 29.1797V39.6758V29.1797Z"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M147.536 12.0955C147.383 11.6358 147.23 11.0995 147 10.6398C144.012 3.43809 134.282 1.75258 124.552 1.90581C116.048 2.21227 108.31 4.35745 105.629 10.5632C105.169 11.6358 104.862 12.7084 104.633 13.781C104.173 16.0028 104.096 17.9947 104.479 19.6036C105.169 21.3657 106.318 22.7448 108.004 23.2045C108.233 23.2811 108.54 23.3577 108.77 23.3577H143.399C144.089 23.3577 144.625 23.2045 145.161 22.9746C146.54 22.3617 147.536 21.0593 148.149 19.527C148.609 17.4584 148.456 14.8536 147.536 12.0955Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M157.726 70.0166L142.479 65.1133H110.838L95.5917 70.0166C90.6118 71.9319 87.3174 76.682 87.3174 81.9683V102.645H166V81.9683C166 76.682 162.705 71.9319 157.726 70.0166Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.62 101.886L142.096 65.418L147.842 73.0794L139.414 80.2811L144.394 86.2569L131.217 98.3619"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.857 97.6724L111.22 65.418L105.397 73.0794L113.902 80.2811L108.922 86.257L122.023 98.3619"
        fill="#fff"
      />
      <path
        d="M124.857 97.6724L111.22 65.418L105.397 73.0794L113.902 80.2811L108.922 86.2569L122.023 98.3619"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgComponent;
